/**
 * Shared validation utility for system settings
 */

/**
 * Validates a setting value based on its type and metadata
 * @param {Object} setting - Setting object with type, metadata, and value
 * @param {boolean} includeFieldName - Whether to include field name in error message
 * @returns {string|null} Error message or null if valid
 */
export function validateSetting(setting, includeFieldName = false) {
    const { type, metadata, value } = setting;
    const fieldPrefix = includeFieldName ? `${metadata.displayName}: ` : '';

    if (type === 'integer') {
        const num = parseInt(value, 10);
        if (isNaN(num)) {
            return `${fieldPrefix}Должно быть целым числом`;
        }
        if (metadata.min !== null && num < metadata.min) {
            return `${fieldPrefix}Не меньше ${metadata.min}`;
        }
        if (metadata.max !== null && num > metadata.max) {
            return `${fieldPrefix}Не больше ${metadata.max}`;
        }
    }

    if (type === 'float') {
        const num = parseFloat(value);
        if (isNaN(num)) {
            return `${fieldPrefix}Должно быть числом`;
        }
        if (metadata.min !== null && num < metadata.min) {
            return `${fieldPrefix}Не меньше ${metadata.min}`;
        }
        if (metadata.max !== null && num > metadata.max) {
            return `${fieldPrefix}Не больше ${metadata.max}`;
        }
    }

    if (type === 'string') {
        if (metadata.options && !metadata.options.includes(value)) {
            return `${fieldPrefix}Допустимые значения: ${metadata.options.join(', ')}`;
        }
        if (metadata.max && value.length > metadata.max) {
            return `${fieldPrefix}Не длиннее ${metadata.max} символов`;
        }
    }

    return null;
}

/**
 * Validates all settings in an array
 * @param {Array} settings - Array of setting objects
 * @returns {Array<string>} Array of error messages (empty if all valid)
 */
export function validateAllSettings(settings) {
    const errors = [];

    for (const setting of settings) {
        const error = validateSetting(setting, true);
        if (error) {
            errors.push(error);
        }
    }

    return errors;
}
